/**
 * Create a search filter
 *
 * @return {function}
 */
export function filter () {
  return function (item, query) {
    return item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
  };
};

/**
 * Create a search result create function
 *
 * @return {function}
 */
export function result () {
  return function (item, query) {
    return `<div class="iono-text-ellipsis">${item.title}</div>`;
  };
};

export default {
  filter, result
};
